const isExecuted = (status) => !!status && status !== 'unexecuted';

const normalize = (status) => status || 'unexecuted';

export function hasDifference(item) {
  return !item.inSource || !item.inTarget || normalize(item.sourceStatus) !== normalize(item.targetStatus);
}

// Tests whose status already matches in both runs need no action, so they are hidden by default.
export function visibleCompareItems(items, showAll) {
  return showAll ? items : items.filter(hasDifference);
}

// Only tests present in both runs can have their result carried over.
export function isSelectable(item) {
  return item.inSource && item.inTarget;
}

export function countOverwrites(items, selectedKeys) {
  return items.filter(item => selectedKeys.has(item.testCaseKey) && isExecuted(item.targetStatus)).length;
}
